import { render } from "./AccountsLoader.vue?vue&type=template&id=2b54d53f&ts=true"
import script from "./AccountsLoader.vue?vue&type=script&lang=ts"
export * from "./AccountsLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__